import { SET_COMPANY_SCOPE, INIT_COMPANY_SCOPE } from "./actionTypes"

// scopeType: 'company' | 'group', scopeId: number
export const setCompanyScope = (scopeType, scopeId) => ({
  type: SET_COMPANY_SCOPE,
  payload: { scopeType, scopeId },
})

export const initCompanyScope = () => ({
  type: INIT_COMPANY_SCOPE,
})
